<template>
    <span>
    <div class="currency-picker" v-for="currency in currencies">
        <div class="form-check two gcg10">
            <input class="form-check-input" type="radio" name="final_currency" :id="'final_currency' + currency.code" :value="currency.value" required @change="$emit('input', currency)" :checked="currency.code === chosenCurrency.code">
            <label class="form-check-label" :for="'final_currency' + currency.code">
                {{currency.emoji}} {{currency.description}} ({{ currency.code }})
            </label>
        </div>
    </div>
    </span>
</template>

<script>
    export default {
        name: "CurrencyPicker",
        props: {
            currencies: '',
            chosenCurrency: {}
        }
    }
</script>

<style scoped>

</style>
